import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import useSeo from "@/lib/useSeo";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/account";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AccountAuth() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  useSeo({ title: "Inloggen — ONUSA" });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "login") { await login(form.email, form.password); }
      else { await register(form.name, form.email, form.password); }
      toast.success("Welkom bij ONUSA");
      navigate("/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="onusa-container py-16 md:py-24 max-w-md" data-testid="account-auth-page">
      <p className="label-x">ONUSA ACCOUNT</p>
      <h1 className="heading-x text-3xl mt-2 mb-8">{mode === "login" ? "INLOGGEN" : "ACCOUNT AANMAKEN"}</h1>
      <button onClick={googleLogin} className="btn-x-outline w-full mb-6" data-testid="google-login-btn">DOORGAAN MET GOOGLE</button>
      <div className="flex items-center gap-3 mb-6"><span className="flex-1 rule-x" /><span className="label-x">OF</span><span className="flex-1 rule-x" /></div>
      <form onSubmit={submit} className="space-y-4">
        {mode === "register" && <input required placeholder="Naam" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="auth-input" data-testid="auth-name" />}
        <input required type="email" placeholder="E-mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="auth-input" data-testid="auth-email" />
        <input required type="password" placeholder="Wachtwoord" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="auth-input" data-testid="auth-password" />
        <button disabled={busy} className="btn-x w-full" data-testid="auth-submit">{busy ? "…" : mode === "login" ? "INLOGGEN" : "ACCOUNT AANMAKEN"}</button>
      </form>
      <div className="flex justify-between mt-5">
        <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="label-x" data-testid="auth-toggle-mode">
          {mode === "login" ? "ACCOUNT AANMAKEN" : "AL EEN ACCOUNT? INLOGGEN"}
        </button>
        {mode === "login" && <Link to="/account/forgot" className="label-x">WACHTWOORD VERGETEN?</Link>}
      </div>
      <style>{`.auth-input{width:100%;background:#fff;border:1px solid #E8E1D8;padding:0.7rem 0.9rem;font-size:0.875rem;outline:none}.auth-input:focus{border-color:#1D1D1B}`}</style>
    </div>
  );
}
